<template>
	<div class="">
		<div class="case-pice"><span class="case-pice-first">学员信息</span> <span class="case-pice-and">/</span> <span class="case-pice-second">查看学员信息</span></div>
		<div class="common-title">
			修改基本信息
			<el-button style='float: right;' size='small' type="info" @click='goBack()' plain>返回</el-button>
		</div>
		<el-row :gutter="20">
			<el-col :span="6">
				<div class="grid-content">学员姓名：{{StudentDetail.name}}</div>
			</el-col>
			<el-col :span="6">
				<div class="grid-content">学员编号：{{StudentDetail.certificationNo}}</div>
			</el-col>
			<el-col :span="6">
				<div class="grid-content">性别：<span v-if="StudentDetail.sex == 1">女</span><span v-else>男</span></div>
			</el-col>
			<el-col :span="6">
				<div class="grid-content">学历：
					<span v-if="StudentDetail.education ==1">初中及以下</span>
					<span v-if="StudentDetail.education ==2">高中/中专</span>
					<span v-if="StudentDetail.education ==3">大专</span>
					<span v-if="StudentDetail.education ==4">本科</span>
					<span v-if="StudentDetail.education ==5">研究生</span>
					<span v-if="StudentDetail.education ==6">博士</span>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="6">
				<div class="grid-content">手机号码：{{StudentDetail.phone}}</div>
			</el-col>
			<el-col :span="12">
				<div class="grid-content">身份证号码：{{StudentDetail.idCard}}</div>
			</el-col>
			<el-col :span="6">
				<div class="grid-content">健康状况：
					<span v-if="StudentDetail.healthState ==1">严重</span>
					<span v-if="StudentDetail.healthState ==2">一切正常</span>
					<span v-if="StudentDetail.healthState ==3">状况欠佳</span>
				</div>
			</el-col>
		</el-row>
		<div class="common-title">
			证件照片
		</div>
		<el-row :gutter="40" id='imgTooles1'>
			<el-col :span="8">
				<div class="grid-img" id='imgTooles' style="position: relative;border:1px solid #CCCCCC;">
					<img @click="preImage2()"  :src="StudentDetail.personImg" :data-original='StudentDetail.personImg' alt="" />
					<i v-if="StudentDetail.personImg!=''" class="el-icon-circle-close img-close-icon" @click="deleteImg('personImg')"></i>
				</div>
				<div style="text-align: center;margin-top: 10px;">
					<el-upload :headers="$util.getUploadHeaders()" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess" :action='actionUrl' :show-file-list='false'>
						<el-button size="small" type="primary">{{buttonText}}</el-button>
					</el-upload>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-img" id='imgTooles' style="position: relative;border:1px solid #CCCCCC;">
					<img @click="preImage2()" :src="StudentDetail.idCardFrontImg" :data-original='StudentDetail.idCardFrontImg' alt="" />
					<i v-if="StudentDetail.idCardFrontImg!=''" class="el-icon-circle-close img-close-icon" @click="deleteImg('idCardFrontImg')"></i>
				</div>
				<!--<div style="text-align: center;margin-top: 10px;">
					<el-upload :before-upload="beforeAvatarUpload" :on-success="handleFrontSuccess" :action='actionUrl' :show-file-list='false'>
						<el-button size="small" type="primary">上传证件正面照</el-button>
					</el-upload>
				</div>-->
			</el-col>
			<el-col :span="8">
				<div class="grid-img" id='imgTooles' style="position: relative;border:1px solid #CCCCCC;">
					<img @click="preImage2()" :src="StudentDetail.idCardBackImg" :data-original='StudentDetail.idCardBackImg' alt="" />
					<i v-if="StudentDetail.idCardBackImg!=''" class="el-icon-circle-close img-close-icon" @click="deleteImg('idCardBackImg')"></i>
				</div>
				<!--<div style="text-align: center;margin-top: 10px;">
					<el-upload :before-upload="beforeAvatarUpload" :on-success="handleBackSuccess" :action='actionUrl' :show-file-list='false'>
						<el-button size="small" type="primary">上传证件背面照</el-button>
					</el-upload>
				</div>-->
			</el-col>
		</el-row>
		<!-- <div class="common-title">
			工作经历
		</div>
		<div v-for="(item,index) in StudentDetail.workHistory" :key='index'>
			<el-row :gutter="20">
				<el-col :span="24">
					<div class="grid-content company-title">{{item.company}} <span style="margin-left: 30px;" class="company-text">{{item.workStartTime}}至 {{item.workEndTime}}</span></div>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="8">
					<div class="grid-content company-text">部门：{{item.department}}</div>
				</el-col>
				<el-col :span="8">
					<div class="grid-content company-text">职位：{{item.position}}</div>
				</el-col>
			</el-row>
			<div>
				<div class="grid-content company-text">
					职责描述
				</div>
				<div style='line-height: 30px;'>
					{{item.workContent}}
				</div>
			</div>
		</div> -->
		<div class="common-title">
			培训记录
		</div>
		<div v-for="(item,index) in StudentDetail.trainingHistory" :key='index'>
			<el-row :gutter="20">
				<el-col :span="24">
					<div class="grid-content company-title">
						{{item.companyName}}
						<!--<span style="margin-left: 30px;" class="company-text">
							<span>{{item.applicationDate.year}}-{{item.applicationDate.monthValue | filterTime}}-{{item.applicationDate.dayOfMonth | filterTime}}</span>
							<span style="margin-left: 10px;">{{item.applicationDate.hour | filterTime}}:{{item.applicationDate.minute | filterTime}}:{{item.applicationDate.second | filterTime}}</span>
						</span>-->
					</div>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="6">
					<div class="grid-content company-text">培训状态：
						<span v-if='item.trainingStatus == 1'>在培</span>
						<span v-if='item.trainingStatus == 2'>结业</span>
					</div>
				</el-col>
				<el-col :span="6">
					<div class="grid-content company-text">培训类别：
						<span v-if='item.trainingClasses == 1'>初次培训</span>
						<span v-if='item.trainingClasses == 2'>继续教育</span>
					</div>
				</el-col>
				<el-col :span="6">
					<div class="grid-content company-text">专业类别：{{item.professionalClasses}}</div>
				</el-col>
				<el-col :span="6">
					<div class="grid-content company-text">培训人员：
						<span v-if='item.trainers == 1'>负责人</span>
						<span v-if='item.trainers == 2'>安全管理人员</span>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import { getStudentDetail, personImg } from '../../api/main'
	import Viewer from 'viewerjs';
	export default {
		data() {
			return {
				StudentDetail: {},
				actionUrl: '',
				//				actionUrl: 'http://19940309.xyz:20005/api/v1/uploadMaterial',
				buttonText: ''
			}
		},
		mounted() {
			this.actionUrl = `${this.$httpUrl}/api/v1/uploadMaterial`
			this.getStudentDetailFn();
		},
		methods: {
			preImage2() {
				const ViewerDom = document.getElementById('imgTooles1');
				const viewer = new Viewer(ViewerDom, {
					url: "data-original"
				});
			},
			deleteImg(url) {
				if(url == 'personImg') {
					this.StudentDetail.personImg = '';
					personImg({
						personImg: this.StudentDetail.personImg,
						studentId: this.StudentDetail.studentId
					}).then(res => {
						this.$message.success('删除成功')
					})
				}
			},
			handleAvatarSuccess(res, file) {
				this.StudentDetail.personImg = res.data;
				personImg({
					personImg: this.StudentDetail.personImg,
					studentId: this.StudentDetail.studentId
				}).then(res => {
					this.$message.success('上传成功')
				})
			},
			handleFrontSuccess(res, file) {
				this.StudentDetail.idCardFrontImg = res.data;
			},
			handleBackSuccess(res, file) {
				this.StudentDetail.idCardBackImg = res.data;
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type;
				if(isJPG == 'image/jpeg' || isJPG == 'image/png') {
					return isJPG;
				} else {
					this.$message.error('上传头像图片只能是JPG或者PNG格式!');
				}
				return false;
			},
			getStudentDetailFn() {
				getStudentDetail(this.$store.state.editStudentId).then(res => {
					console.log("editStudentId",this.$store.state.editStudentId)
					this.StudentDetail = res.data;
					if(res.data.personImg == '') {
						this.buttonText = '学员照片上传'
					} else {
						this.buttonText = '学员照片重新上传'
					}
				})
			},
			goBack() {
				this.$router.go(-1);
			},
			search() {

			},
		}
	}
</script>

<style lang="less">
	.company-change-detail {
		font-size: 16px;
	}
</style>